<script lang="ts">
    import { setVideoBorderRadius } from '$lib/global/helper/player';

    import Player from 'svelte-react-player';

    import Close from './Close.svelte';
    import FullscreenCta from './FullscreenCta.svelte';
    import Preview from './Preview.svelte';

    import type { Language } from '$lib/types/Language';

    export let loading = true;
    export let url = '';
    export let ctaVisible = false;
    export let onBtnClick: () => Promise<void> | void = () => {};
    export let btnText = 'Click me!';
    export let btnBgColor = '#0076FF';
    export let btnColor = '#F0F0F0';
    export let thumbnail = '';
    export let onProgress: (progress: { playedSeconds: number }) => void = () => null;
    export let ratio = '56.25%';
    export let language: Language = 'en';
    export let buttonBorderRadiusClass: string = '';
    export let containerBorderRadiusClass: string = '';

    let playing = false;

    const handlePlay = () => {
        playing = true;
    };

    const handleClose = () => {
        playing = false;
    };
</script>

<div>
    <div style="display: {playing ? 'none' : 'block'}">
        <Preview
            onPlayClick={handlePlay}
            src={thumbnail}
            {loading}
            {language}
            {containerBorderRadiusClass}
        />
    </div>
    {#if playing}
        <div class="playerWrapper">
            <Player
                {url}
                {playing}
                controls
                fluid
                {ratio}
                playsinline
                callbacks={{ onProgress, onReady: setVideoBorderRadius }}
            />
            <Close onClose={handleClose} />
            <FullscreenCta
                {btnText}
                {btnColor}
                {btnBgColor}
                {onBtnClick}
                visible={ctaVisible}
                {buttonBorderRadiusClass}
            />
        </div>
    {/if}
</div>

<style lang="scss">
    .playerWrapper {
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background-color: black;
        z-index: 999;
        overflow-y: hidden;
        display: flex;
        align-items: center;
    }
</style>
